export const USER_PLAN_COUNT = 2
export const STORE_USER_PLANS = '@STORE/STORAGE_USER_PLANS'
export const USER_AUTH = '@LOGGER/USER_AUTH'
export const USER_LOGOUT = '@LOGGER/USER_LOGOUT'
export const CREATED = '@LOGGER/CREATED'
export const UPDATED = '@LOGGER/UPDATED'
export const DELETED = '@LOGGER/DELETED'
export const BIOMETRY_SUCCESS = '@LOGGER/BIOMETRY_SUCCESS'



// WEBPACK FOOTER //
// /src/helpers/constants.js